import {Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DispensaryService extends BaseService {
  private resourceUrl = this.apiUrl + 'dispensary';

  constructor(private http: HttpClient) {
    super();
  }

  getDispensary(disp_id, ) {
    return this.http.get(this.resourceUrl + `/${disp_id}`);
  }

  fetchDispensary(disp_id, sort_key , weight_keys, keyword, page, cat_id) {
    const params: any = { sort_key, weight_keys, keyword, page, cat_id };
    const httpOptions = { headers: this.httpOptions.headers, params: params };

    return this.http.get(this.resourceUrl + `/${disp_id}/filterItems`, httpOptions);
  }

  getSupportedLocations(dispId: string){
    return this.http.get(this.resourceUrl + '/supportedlocations' + `/${dispId}`);
  }
}
